import React, { useState } from "react";
import DashboardLayout from "../../../layouts/Dashboard";
import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";
import { FactorSelect } from "../../../components/Select/domainSelects";
import { setValue } from "../../../functions/entityHelpers";

const CommitteeObjectList = () => {
    const [entity, setEntity] = useState({});

    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="committeeObject"
                hasCode={true}
                hasDescription={true}
                entity={entity}
                setEntity={setEntity}
                extraColumns={[
                    {
                        title: "Фактор",
                        dataIndex: "factor",
                        key: "factor",
                        render: (_, row) => row.factor?.name || row.factorId || "",
                    },
                ]}
                createFields={[
                    <FactorSelect
                        key="factor"
                        label="Фактор"
                        value={entity.factorId}
                        onChange={(val) => setValue("factorId", val, entity, setEntity)}
                        fullWidth
                    />,
                ]}
                editFields={[
                    <FactorSelect
                        key="factor"
                        label="Фактор"
                        value={entity.factorId}
                        onChange={(val) => setValue("factorId", val, entity, setEntity)}
                        fullWidth
                    />,
                ]}
                detailsFields={[
                    "Фактор: " + (entity.factor?.name || entity.factorId || "—"),
                ]}
            />
        </DashboardLayout>
    );
};

export default CommitteeObjectList;
